export default "__VITE_ASSET__71V4uGne__"